import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

const min = 2;
const max = 6;
const rndRot = () =>
  (Math.random() * (max - min + 1) + min) * (Math.random() < 0.5 ? -1 : 1);
const staticHost = process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST;

export const StyledTextPage = styled.div`
  .wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 20px;
    .text-with-audio {
      position: relative;
      z-index: 1;
      padding: 0;
      flex: 5;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .text {
        max-width: 18em;
        font-size: 120%;

        ul li {
          font-size: 25px;
          line-height: 1.3;
          margin-bottom: 20px;
        }
      }
      .audio-player {
      }
    }
    .text-backdrop {
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      background: url(${staticHost}/img/public-page/drop-darker.svg);
      background-size: contains;
      background-repeat: no-repeat;
      background-position: center;
    }
    .image-wrapper {
      flex: 3;
      padding: 10px 32px;
      margin: 48px 0;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: white;
      background-color: ${Colors.backgroundPaleBlueDark};

      .ant-image {
        transform: rotate(${(props) => rndRot()}deg);
        width: 115%;
        margin: -12px 0;
        padding: 12px;
        box-shadow: -1px 2px 3px 0 ${Colors.lighterGray}88;
        border: 1px solid ${Colors.lighterGray}aa;
        background-color: white;
        img {
          border: 1px solid ${Colors.lighterGray}66;
          border-radius: 10px;
        }
      }
    }
  }
  @media only screen and (max-height: 500px) and (orientation: landscape) {
    .wrapper {
      .text-with-audio {
        flex: 6;
        .text {
          line-height: 1.3;
          max-width: unset;
          font-size: unset;
          ul {
            li {
              font-size: unset;
              margin: 6px;
            }
          }
        }
      }
      .image-wrapper {
        flex: 2;
        .ant-image {
          width: 170%;
        }
      }
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    .wrapper {
      flex-direction: column;
    }
  }
`;
